/**
 * vo-timeline.js — window.VOTimeline
 *
 * ОБЩАЯ ВРЕМЕННАЯ ШКАЛА для «Виртуального оркестра».
 *
 * Зачем она вообще. Тул существует ради ОДНОГО: партии, записанные порознь,
 * должны встать в такт. До этой шкалы результат этой работы был виден только
 * СЛОВАМИ («сдвинута на 350 мс»), а картинка врала: каждая партия рисовалась в
 * своей карточке от нуля, то есть ровно так, будто никакого выравнивания не
 * было. Человек не мог увидеть ни того, что партии сошлись, ни того, что одна
 * из них вступает позже. Замер до переделки (1440×900, три партии): карточки
 * по 171 px, кнопка сборки на 1580 px при экране 900.
 *
 * Здесь партии лежат на ОДНОЙ оси времени, каждая на своём месте, а поверх
 * всех — доли опорной партии. Разъехавшаяся партия видна глазом.
 *
 * ── Что здесь есть и чего здесь нет ──────────────────────────────────────
 *   layout()    ЧИСТЫЙ расчёт «где что окажется» — отдельно от рисования,
 *               чтобы проверять его без канвы (тот же приём, что у
 *               AudioMixdown.plan)
 *   drawStrip() рисование одной полосы
 *   drawRuler() линейка времени с долями
 *
 * Пики берутся у WaveformPreview.peaks/paint — второй расчёт пиков в туле
 * означал бы две картинки одного звука, которые однажды разойдутся.
 */
(function (w) {
    'use strict';

    /* Сколько столбцов пиков считать на партию. Больше не значит точнее:
       полоса редко шире 900 CSS-px, а пики всё равно ужимаются под ширину. */
    var PEAK_COLUMNS = 900;

    /**
     * Где окажется каждая партия на общей оси, в ДОЛЯХ ширины (0..1).
     *
     * Чистая функция: ни канвы, ни DOM. `totalSec` задаётся снаружи, потому
     * что его же считает сборка — шкала обязана показывать ту длину, которая
     * получится в файле, а не свою.
     */
    function layout(model) {
        model = model || {};
        var parts = model.parts || [];
        var total = +model.totalSec > 0 ? +model.totalSec : 0;
        if (!(total > 0)) {
            for (var t = 0; t < parts.length; t++) {
                var e = (parts[t].offsetSec || 0) + (parts[t].durationSec || 0);
                if (e > total) total = e;
            }
        }
        if (!(total > 0)) total = 1;
        var spans = [];
        for (var i = 0; i < parts.length; i++) {
            var p = parts[i];
            var start = Math.max(0, p.offsetSec || 0);
            /* Зацикленная партия занимает всё, что осталось до конца трека —
               ровно как её услышат. Рисовать её по длине исходника значило бы
               показывать не то, что получится. */
            var end = p.loop ? total : start + (p.durationSec || 0);
            spans.push({
                id: p.id,
                x0: Math.max(0, Math.min(1, start / total)),
                x1: Math.max(0, Math.min(1, end / total)),
                clipped: end > total + 1e-6
            });
        }
        return { totalSec: total, spans: spans };
    }

    /** Пики партии считаются один раз и живут на самой партии. */
    function peaksOf(part) {
        if (!part || !part.buffer) return null;
        if (part._peaks && part._peaksFor === part.buffer) return part._peaks;
        if (!w.WaveformPreview || typeof w.WaveformPreview.peaks !== 'function') return null;
        try {
            part._peaks = w.WaveformPreview.peaks(part.buffer, PEAK_COLUMNS);
            part._peaksFor = part.buffer;
        } catch (e) { part._peaks = null; }
        return part._peaks;
    }

    /** Кэш пиков недействителен (сменился инструмент, файл, натяжение). */
    function dropPeaks(part) { if (part) { part._peaks = null; part._peaksFor = null; } }

    function prep(canvas, cssW, cssH) {
        var dpr = w.devicePixelRatio || 1;
        /* Пол в единицу: канва с нулевым битмапом рисует пустоту, а
           html2canvas на ней падает и уносит весь отчёт (общий класс). */
        var bw = Math.max(1, Math.round(cssW * dpr));
        var bh = Math.max(1, Math.round(cssH * dpr));
        if (canvas.width !== bw) canvas.width = bw;
        if (canvas.height !== bh) canvas.height = bh;
        var ctx = canvas.getContext('2d');
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.clearRect(0, 0, cssW, cssH);
        return ctx;
    }

    var GRID_DEFAULT = 'rgba(255,255,255,.10)';
    var WAVE_DEFAULT = 'rgba(122,162,255,.85)';
    var MUTED_COLOR = 'rgba(148,163,184,.42)';

    /**
     * Полоса одной партии.
     *
     * part: { buffer, offsetSec, durationSec, loop, muted }
     * o:    { totalSec, beats, color, gridColor, cssW, cssH, dim }
     */
    function drawStrip(canvas, part, o) {
        o = o || {};
        var cssW = o.cssW || canvas.clientWidth || 1;
        var cssH = o.cssH || canvas.clientHeight || 1;
        var ctx = prep(canvas, cssW, cssH);
        var total = +o.totalSec > 0 ? +o.totalSec : 1;
        var pxPerSec = cssW / total;

        /* Доли опорной — ПОД звуком, чтобы не спорить с ним за внимание. */
        var beats = o.beats || [];
        if (beats.length) {
            ctx.fillStyle = o.gridColor || GRID_DEFAULT;
            for (var b = 0; b < beats.length; b++) {
                var x = beats[b] * pxPerSec;
                if (x < 0 || x > cssW) continue;
                ctx.fillRect(Math.round(x), 0, 1, cssH);
            }
        }

        var pk = peaksOf(part);
        if (!pk) return;
        var start = Math.max(0, part.offsetSec || 0);
        var dur = part.durationSec || (part.buffer ? part.buffer.duration : 0);
        if (!(dur > 0)) return;
        var col = o.color || WAVE_DEFAULT;
        if (part.muted || o.dim) col = MUTED_COLOR;

        /* Петля рисуется повторами — столько, сколько прозвучит. Предел в 64
           повтора не про красоту: партия в 0.2 с под пятиминутным треком дала
           бы полторы тысячи вызовов рисования на каждый кадр воспроизведения. */
        var reps = part.loop ? Math.min(64, Math.max(1, Math.ceil((total - start) / dur))) : 1;
        for (var r = 0; r < reps; r++) {
            var x0 = (start + r * dur) * pxPerSec;
            if (x0 >= cssW) break;
            var wpx = dur * pxPerSec;
            if (x0 + wpx > cssW) wpx = cssW - x0;
            if (wpx < 1) break;
            w.WaveformPreview.paint(ctx, pk, x0, 0, wpx, cssH, col);
            if (r > 0) {
                ctx.fillStyle = o.gridColor || GRID_DEFAULT;
                ctx.fillRect(Math.round(x0), 0, 1, cssH);
            }
        }

        /* Доли опорной ЕЩЁ РАЗ, поверх звука и слабее. Ради этого тул и
           существует: увидеть, что удары партии приходятся на доли опоры.
           Под звуком сетка не видна там, где звук плотный, — то есть ровно
           там, где на неё и смотрят. */
        if (beats.length) {
            ctx.save();
            ctx.globalAlpha = 0.4;
            ctx.fillStyle = o.gridColor || GRID_DEFAULT;
            for (var g = 0; g < beats.length; g++) {
                var gx = beats[g] * pxPerSec;
                if (gx < 0 || gx > cssW) continue;
                ctx.fillRect(Math.round(gx), 0, 1, cssH);
            }
            ctx.restore();
        }
    }

    /**
     * Линейка: секунды и доли опорной партии.
     *
     * Шаг подписей выбирается от МАСШТАБА, а не от числа: при трёхминутном
     * треке подпись на каждой секунде — это каша из цифр.
     */
    var STEPS = [1, 2, 5, 10, 15, 30, 60, 120, 300];

    function stepFor(pxPerSec, minPx) {
        var need = minPx || 56;
        for (var i = 0; i < STEPS.length; i++) {
            if (STEPS[i] * pxPerSec >= need) return STEPS[i];
        }
        return STEPS[STEPS.length - 1];
    }

    function drawRuler(canvas, o) {
        o = o || {};
        var cssW = o.cssW || canvas.clientWidth || 1;
        var cssH = o.cssH || canvas.clientHeight || 1;
        var ctx = prep(canvas, cssW, cssH);
        var total = +o.totalSec > 0 ? +o.totalSec : 1;
        var pxPerSec = cssW / total;
        var step = stepFor(pxPerSec);

        var beats = o.beats || [];
        if (beats.length) {
            ctx.fillStyle = o.gridColor || 'rgba(255,255,255,.18)';
            for (var b = 0; b < beats.length; b++) {
                var bx = beats[b] * pxPerSec;
                if (bx < 0 || bx > cssW) continue;
                ctx.fillRect(Math.round(bx), cssH - 4, 1, 4);
            }
        }

        ctx.fillStyle = o.tickColor || 'rgba(255,255,255,.36)';
        ctx.font = '10px ui-sans-serif, system-ui, sans-serif';
        ctx.textBaseline = 'top';
        for (var s = 0; s <= total + 1e-6; s += step) {
            var x = s * pxPerSec;
            if (x > cssW) break;
            ctx.fillRect(Math.round(x), 0, 1, cssH);
            var lab = fmtClock(s);
            var tw = ctx.measureText(lab).width;
            /* Подпись у правого края уехала бы за канву — прижимаем её. */
            ctx.fillText(lab, Math.min(x + 3, Math.max(0, cssW - tw - 1)), 1);
        }
    }

    function fmtClock(sec) {
        sec = Math.max(0, Math.round(sec));
        var m = Math.floor(sec / 60), s = sec % 60;
        return m + ':' + (s < 10 ? '0' : '') + s;
    }

    w.VOTimeline = {
        layout: layout,
        drawStrip: drawStrip,
        drawRuler: drawRuler,
        dropPeaks: dropPeaks,
        fmtClock: fmtClock,
        stepFor: stepFor,
        PEAK_COLUMNS: PEAK_COLUMNS
    };
})(window);
